<template>
    <div class="form-group bg-light">
            <hr>
        <div class="col-md-12">
            <p class="animated fadeIn h4 mb-0 mt-3 mx-auto py-2">File Upload</p>
            <label for="logo" class="control-label w-100">(PDF, JPG or PNG)</label>
             <div class="form-group">
                <input type="file" multiple="multiple" id="attachments" @change="uploadFieldChange">
            </div>
                <!-- <hr> -->
                <div class="form-group files">
                    <p class="animated mt-3 fadeIn mb-0 mx-auto py-2">Currently Uploaded Files</p>
                    <div class="attachment-holder animated fadeIn" :key="index" v-cloak v-for="(attachment, index) in attachments">
                        <div class="border d-flex flex-wrap form-group p-1 mb-0">
                            <span class="col-8 pt-2 text-uppercase">
                                <a :href="'../'+attachment.path" target="_blank" class="text-info">{{attachment.name}}
                                </a>
                            </span>
                            <span class="col-4 text-right" @click="removeAttachment(attachment)"><button class="btn btn-xs btn-danger">Remove</button></span>
                        </div>
                    </div>
                </div>
        </div>
        <hr class='py-3'>
    </div>
</template>
<script>
    export default {
        name:"FileManagement",
        props: [
            'settings', 'currentAttachments'
        ],
        mounted(){
            console.log('file uploader mounted');
            this.$nextTick(()=>{
                this.currentAttachments.length > 0 ? this.attachments = this.currentAttachments : null
            })
            },
        data() {

            return {

                // You can store all your files here
                attachments: [],

                attachment_labels: [], // List of old uploaded files coming from the server

                categories: [],

                // Each file will need to be sent as FormData element
                fileData: new FormData(),

                percentCompleted: 0,

            }

        },

        watch: {
        },

        computed: {
        },

        methods: {
            validate() {
                if (!this.attachments.length) {
                    this.$store.commit('SHOW_ERRORS',{files:['Please attach the file(s) showing your '+this.$store.state.billsRequired+' months of Showtime service.']})
                    return false;
                }
                return true;
            },


            getAttachmentSize() {

                this.upload_size = 0; // Reset to beginningƒ

                this.attachments.map((item) => { this.upload_size += parseInt(item.size); });

                this.upload_size = Number((this.upload_size).toFixed(1));

                //this.$forceUpdate();

            },

            prepareFiles() {

                for (var i = this.attachments.length - 1; i >= 0; i--) {
                    this.$parent.payload.append('files['+i+']', this.attachments[i]);
                    console.log(this.attachments[i])
                    //this.$parent.payload.rebate.attachments.push(this.attachments[i]);

                }

                for (var i = this.attachment_labels.length - 1; i >= 0; i--) {
                    this.$parent.payload.append("attachment_labels[]", JSON.stringify(this.attachment_labels[i]));
                    //this.$parent.payload.rebate.append("attachment_labels[]", JSON.stringify(this.attachment_labels[i]));
                }

            },

            removeAttachment(attachment) {

                this.attachments.splice(this.attachments.indexOf(attachment), 1);
                //this.$parent.payload.rebate.attachments.splice(this.attachments.indexOf(attachment), 1);;
                this.getAttachmentSize();

            },

            // This function will be called every time you add a file
            uploadFieldChange(e) {

                var files = e.target.files || e.dataTransfer.files;
                if (!files.length)
                    return;

                for (var i = files.length - 1; i >= 0; i--) {
                    this.attachments.push(files[i]);
                   //attachments.push(files[i]);
                }

                // Reset the form to avoid copying these files multiple times into this.attachments
                document.getElementById("attachments").value = [];
            },


            // We want to clear the FormData object on every upload so we can re-calculate new files again.
            // Keep in mind that we can delete files as well so in the future we will need to keep track of that as well
            resetData() {
                this.fileData = new FormData(); // Reset it completely
                this.attachments = [];
            },

            start() {
                console.log('Starting File Management Component');
            },

        },

        created() {
            this.start();
        }

    }
</script>
